import { render, staticRenderFns } from "./promote.vue?vue&type=template&id=0468ecc2&scoped=true&"
import script from "./promote.vue?vue&type=script&lang=js&"
export * from "./promote.vue?vue&type=script&lang=js&"
import style0 from "./promote.vue?vue&type=style&index=0&id=0468ecc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0468ecc2",
  null
  
)

export default component.exports